const middleware = {}

middleware['authentication'] = require('../middleware/authentication.js')
middleware['authentication'] = middleware['authentication'].default || middleware['authentication']

middleware['featured-basic'] = require('../middleware/featured-basic.js')
middleware['featured-basic'] = middleware['featured-basic'].default || middleware['featured-basic']

middleware['featured'] = require('../middleware/featured.js')
middleware['featured'] = middleware['featured'].default || middleware['featured']

middleware['guest'] = require('../middleware/guest.js')
middleware['guest'] = middleware['guest'].default || middleware['guest']

middleware['logoutCookies'] = require('../middleware/logoutCookies.js')
middleware['logoutCookies'] = middleware['logoutCookies'].default || middleware['logoutCookies']

middleware['published'] = require('../middleware/published.js')
middleware['published'] = middleware['published'].default || middleware['published']

middleware['redirect-v2-backwards'] = require('../middleware/redirect-v2-backwards.js')
middleware['redirect-v2-backwards'] = middleware['redirect-v2-backwards'].default || middleware['redirect-v2-backwards']

middleware['redirect'] = require('../middleware/redirect.js')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

middleware['ssr-cookie'] = require('../middleware/ssr-cookie.js')
middleware['ssr-cookie'] = middleware['ssr-cookie'].default || middleware['ssr-cookie']

export default middleware
